import m from "./design-system.es190.js";
import { openBlock as c, createElementBlock as w, createElementVNode as u, normalizeStyle as d, createTextVNode as v } from "vue";
/* empty css                    */
import C from "./design-system.es128.js";
const b = (t, e, s) => {
  e || t.preventDefault();
  const a = s.clientWidth, r = s.clientHeight, n = s.getBoundingClientRect().left + window.pageXOffset, o = s.getBoundingClientRect().top + window.pageYOffset, g = t.pageX || (t.touches ? t.touches[0].pageX : 0), p = t.pageY || (t.touches ? t.touches[0].pageY : 0);
  let l = g - n, h = p - o;
  l < 0 ? l = 0 : l > a ? l = a : h < 0 ? h = 0 : h > r && (h = r);
  const f = l / a;
  let i = -(h / r) + 1;
  return i = i > 0 ? i : 0, i = i > 1 ? 1 : i, { bright: i, saturation: f };
}, E = {
  name: "DsSaturation",
  props: {
    value: Object
  },
  emits: ["change"],
  computed: {
    bgColor() {
      return `hsl(${this.value.hsv.h}, 100%, 50%)`;
    },
    pointerTop() {
      return `${-(this.value.hsv.v * 100) + 1 + 100}%`;
    },
    pointerLeft() {
      return `${this.value.hsv.s * 100}%`;
    }
  },
  beforeUnmount() {
    this.unbindEventListeners();
  },
  methods: {
    throttle: m(
      (t, e) => {
        t(e);
      },
      20,
      {
        leading: !0,
        trailing: !1
      }
    ),
    handleChange(t, e) {
      const { container: s } = this.$refs, { bright: a, saturation: r } = b(t, e, s);
      this.throttle(this.onChange, {
        h: this.value.hsv.h,
        s: r,
        v: a,
        a: this.value.hsv.a,
        source: "hsva"
      });
    },
    onChange(t) {
      this.$emit("change", t);
    },
    handleMouseDown(t) {
      this.handleChange(t, !0), this.bindEventListeners();
    },
    handleMouseUp() {
      this.unbindEventListeners();
    },
    bindEventListeners() {
      window.addEventListener("mousemove", this.handleChange), window.addEventListener("mouseup", this.handleChange), window.addEventListener("mouseup", this.handleMouseUp);
    },
    unbindEventListeners() {
      window.removeEventListener("mousemove", this.handleChange), window.removeEventListener("mouseup", this.handleChange), window.removeEventListener("mouseup", this.handleMouseUp);
    }
  }
}, L = { class: "vc-chrome-saturation-wrap" };
function M(t, e, s, a, r, n) {
  return c(), w("div", L, [
    u("div", {
      ref: "container",
      role: "saturationPanel",
      class: "vc-saturation",
      style: d({ background: n.bgColor }),
      onMousedown: e[0] || (e[0] = (...o) => n.handleMouseDown && n.handleMouseDown(...o)),
      onTouchmove: e[1] || (e[1] = (...o) => n.handleChange && n.handleChange(...o)),
      onTouchstart: e[2] || (e[2] = (...o) => n.handleChange && n.handleChange(...o))
    }, [
      e[4] || (e[4] = u("div", { class: "vc-saturation--white" }, null, -1)),
      e[5] || (e[5] = v()),
      e[6] || (e[6] = u("div", { class: "vc-saturation--black" }, null, -1)),
      e[7] || (e[7] = v()),
      u("div", {
        role: "currentSaturationPointer",
        class: "vc-saturation-pointer",
        style: d({ top: n.pointerTop, left: n.pointerLeft })
      }, e[3] || (e[3] = [
        u("div", { class: "vc-saturation-circle" }, null, -1)
      ]), 4)
    ], 36)
  ]);
}
const k = /* @__PURE__ */ C(E, [["render", M]]);
export {
  k as default
};
//# sourceMappingURL=design-system.es121.js.map
